// src/services/authService.js
import api from '../api' // ou '@/api' si tu as un alias

export default {
  login(credentials) {
    return api.post('/login', credentials)
  },

  logout() {
    return api.post('/logout')
  },

  getUser(id) {
    return api.get(`/getUser/${id}`)
  }
}
